export function placeholderSvgDataUrl({
  width,
  height,
  text,
  bg = '#1A1A1A',
  fg = '#FFD700',
}) {
  const safeText = String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
  <rect width="100%" height="100%" fill="${bg}"/>
  <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
        fill="${fg}" font-family="Arial, sans-serif" font-size="${Math.max(12, Math.round(Math.min(width, height) * 0.06))}" font-weight="700">
    ${safeText}
  </text>
</svg>`;

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

